import React from "react";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import APComplianceWholeMill from "./APComplianceWholeMill/APComplianceWholeMill.view";
import APComplianceByResponsible from "./APComplianceByResponsible";

const APCompliance = () => {
    const mainClasses = useRCAMainStyles();

    return (
        <>
            <div className={mainClasses.contentWrapper}>
                <APComplianceWholeMill />
            </div>
            <div className={mainClasses.contentWrapper}>
                <APComplianceByResponsible />
            </div>
        </>
    );
};

export default APCompliance;
